<script setup>
import { inject, watch } from 'vue'
import AppDialog from '#/general/AppDialog'
import DetailsReport from '#/detailsReport/DetailsReport'
import B2CSearchBox from 'components/home/B2CSearchBox'
import { useVModel } from '@vueuse/core'
const { global, screen } = inject('Shared')
const props = defineProps({ visible: Boolean })
const emit = defineEmits(['update:visible'])
const visible = useVModel(props, 'visible', emit)
watch(() => props.visible, v => {
  if (v) {
    document.body.style = 'max-height: 100vh; overflow: hidden'
  } else {
    document.body.style = 'max-height: auto; overflow: auto'
  }
})
</script>

<template lang="pug">
app-dialog(v-model:show-modal="visible" maximized fixed)
  template(#modal-content)
    .demo--container
      .demo--close(@click="visible = false")
        svg(width='18' height='18' viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg')
          path(d='M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z' fill='black')
      details-report(:version="2" demo)
        template(#ctaSlot)
          .demo-cta--container
            .demo-cta--title.lt-sm
              div «Versteckt sich in Ihrem Einfamilien- haus auch ein Mehrfamilienhaus?
              div Mit uns finden Sie es raus!»
            img.demo-cta--img(src="~assets/img/aboutUs/Magdalena.png")
            .demo-cta--content
              .demo-cta--title.gt-sm
                div «Versteckt sich in Ihrem Einfamilien-
                div haus auch ein Mehrfamilienhaus?
                div Mit uns finden Sie es raus!»
              .demo-cta--name Magdalena Haslinger
              .demo-cta--company Raumpionierin
              .demo-cta--search
                b2-c-search-box(
                  btnText="Jetzt Potenzial prüfen!"
                  btnTextMobile="Jetzt prüfen!"
                  inputColor="#2F3849"
                  inputBg="white"
                )
        template(#bottomSlot)
          .demo-cta--sign-text Beachten Sie, dass das vorliegende Ergebnis auf einer automatisierten Analyse öffentlich verfügbarer Informationen beruht und kein Ersatz für eine detaillierte manuelle Analyse der Nutzungsmöglichkeiten der betroffenen Parzelle ist. Jegliche Haftung der Raumpioniere AG für das vorliegende Ergebnis und allfällige gestützt darauf getroffene oder unterbliebene Kauf- bzw. Verkaufsentscheidungen sind – soweit gesetzlich zulässig – ausgeschlossen.
</template>

<style scoped lang="sass">
.demo--container
  width: 100vw
  height: 100vh
  minheight: 100vh
  min-height: -webkit-fill-available
  background: white
  overflow: auto
  .demo--close
    position: absolute
    width: 14px
    height: 14px
    cursor: pointer
    z-index: 100
    @media screen and (min-width: 1024px)
      right: 40px
      top: 32px
    @media screen and (max-width: 1024px)
      right: 25px
      top: 17px
.demo-cta--container
  background: white
  box-shadow: 0px 15px 30px rgba(34, 34, 60, 0.17)
  border-radius: 10px
  border: 1px solid #D9D9D9
  @media screen and (min-width: 1024px)
    padding: 65px
    display: flex
    flex-direction: row
    margin-top: 50px
  @media screen and (max-width: 1024px)
    margin-top: 20px
    padding: 20px
    display: flex
    flex-direction: column
    align-items: center
    justify-content: center
  .demo-cta--img
    width: 200px
    min-width: 200px
    max-width: 200px
    min-height: 200px
    height: 200px
    max-height: 200px
    border-radius: 144px
    object-fit: contain
  .demo-cta--title
    color: #2E3646
    font-weight: 700
    @media screen and (min-width: 1024px)
      margin-left: 67px
      margin-bottom: 30px
      font-size: 30px
      line-height: 37px
    @media screen and (max-width: 1024px)
      font-size: 20px
      line-height: 30px
      margin-bottom: 15px
  .demo-cta--content
    width: 100%
    .demo-cta--name
      font-weight: 700
      color: #1F47CD
      @media screen and (min-width: 1024px)
        margin-left: 67px
        font-size: 20px
        line-height: 25px
      @media screen and (max-width: 1023px)
        margin-top: 10px
        font-size: 22px
        line-height: 22px
        text-align: center
    .demo-cta--company
      font-weight: 500
      @media screen and (min-width: 1024px)
        margin-left: 67px
        font-size: 20px
      @media screen and (max-width: 1023px)
        font-size: 18px
        text-align: center
    .demo-cta--search
      margin-top: 30px
      @media screen and (min-width: 1100px)
        margin-left: 46px
      @media screen and (max-width: 1100px)
.demo-cta--sign-text
  margin: 30px 0 60px 0
  font-weight: 500
  font-size: 10px
  line-height: 150%
  width: 100%
  display: flex
  align-items: center
  text-align: center
  color: #22223C
</style>
